module.exports = __webpack_public_path__ + "img/Weapon_197.c32e5c62.png";